import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { ProgressSpinner } from "primereact/progressspinner";
import ym from "react-yandex-metrika";
import { api } from "../../services/api";

function setNoReferrerMeta() {
  let meta = document.querySelector('meta[name="referrer"]');
  if (!meta) {
    meta = document.createElement("meta");
    meta.name = "referrer";
    document.head.appendChild(meta);
  }
  meta.content = "no-referrer";
}

export function PayPalReturn() {
  const location = useLocation();
  const history = useHistory();
  const [status, setStatus] = useState("processing");

  useEffect(() => {
    setNoReferrerMeta();
    const query = new URLSearchParams(location.search);
    const paypalOrderId = query.get("token");
    const expectedOrderId = sessionStorage.getItem("paypalOrderId");

    if (!paypalOrderId) {
      setStatus("error");
      return;
    }

    if (expectedOrderId && expectedOrderId !== paypalOrderId) {
      setStatus("error");
      return;
    }

    (async () => {
      try {
        const response = await api.post(`payment/paypal/capture/${paypalOrderId}`);
        sessionStorage.removeItem("paypalOrderId");

        if (response.data?.status === "success") {
          ym("reachGoal", "purchase_completed");
          setStatus("success");
          setTimeout(() => history.push("/"), 3000);
        } else {
          setStatus("error");
        }
      } catch (err) {
        console.error("PayPal capture error:", err);
        setStatus("error");
      }
    })();
  }, [location.search, history]);

  return (
    <div style={wrapper}>
      {status === "processing" && <ProgressSpinner />}
      {status === "success" && <div style={message}>Payment confirmed. Redirecting…</div>}
      {status === "error" && <div style={message}>Payment could not be confirmed. Please contact support.</div>}
    </div>
  );
}

const wrapper = {
  width: "100%",
  height: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
  padding: "1rem",
};

const message = {
  color: "#fff",
  fontSize: "1.1rem",
};

export default PayPalReturn;
